import React from 'react'

const MasterDetailNav = ({ onBackClick }) => (
  <div className="row MasterDetailNav">
    <div className="col">
      <button onClick={onBackClick}>〈 Back</button>
    </div>
  </div>
)

export default MasterDetailNav



// WEBPACK FOOTER //
// ./src/components/MasterDetail/MasterDetailNav/MasterDetailNav.js